module.exports = __webpack_public_path__ + "static/media/draggable-polyline.e181fb27.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/draggable-polyline.png
// module id = 37
// module chunks = 0